import React, { useState } from 'react'
import './index.scss'
import { getStringDate } from '@App/helpers/get-string-date'
import ModalPortal from '@Components/Popups/ModalPortal'
import { UserInfo } from '@Entities/user/user'
import UserRowPopup from '@Components/UserRowComponent/UserRowPopup'
import { UserMaintenanceActions } from '@Components/UserRowComponent/user-maintenance-actions'
import EmailStatusBlock from '@Components/UserRowComponent/EmailStatusBlock'
import UserActivityBlock from '@Components/UserRowComponent/UserActivityBlock'
import UserInfoBlock from '@Components/UserRowComponent/UserInfoBlock'

interface UserRowComponentProps {
    userData: UserInfo
    onReloadData?(): void
    noDots?: boolean
}

const UserRowComponent = (props: UserRowComponentProps) => {
    const { userData, onReloadData, noDots } = props

    const [actionType, setActionType] = useState<UserMaintenanceActions>()
    const [confirmPopupIsOpen, setConfirmPopupIsOpen] = useState<boolean>(false)

    const onOpenConfirmPopup = (userAction: UserMaintenanceActions) => {
        setActionType(userAction)
        setConfirmPopupIsOpen(true)
    }

    const onCloseConfirmPopup = () => {
        setConfirmPopupIsOpen(false)
    }

    const { exposedId, lastActivity } = userData
    const lastActivityDateString = lastActivity ? getStringDate(lastActivity) : ''

    return (
        <div className="user-row-component">
            <div className="user-row-head">
                <UserInfoBlock userData={userData} />
                <UserActivityBlock
                    exposedUserId={exposedId}
                    onOpenConfirmPopup={onOpenConfirmPopup}
                    noDots={noDots}
                    lastActivityDateString={lastActivityDateString}
                />
            </div>
            <EmailStatusBlock userData={userData} lastActivityDateString={lastActivityDateString} />

            <ModalPortal isOpen={confirmPopupIsOpen} onClose={onCloseConfirmPopup}>
                <UserRowPopup
                    userData={userData}
                    onReloadData={onReloadData}
                    onCloseConfirmPopup={onCloseConfirmPopup}
                    actionType={actionType}
                />
            </ModalPortal>
        </div>
    )
}

export default UserRowComponent
